// extracted by mini-css-extract-plugin
export default {"container":"PayerSelect-container_dtVUG","badge":"PayerSelect-badge_OzqaG","linksContainer":"PayerSelect-linksContainer_Y32Xz","separator":"PayerSelect-separator_MYYN0"};